import { ArrayUtils } from '@wix/premium-cart-common';
import { CartEnrichers } from './index';
export const enrichCart = props => {
  const {
    cart,
    productTypesDetails
  } = props;
  const lineItems = cart.lineItems;
  let cartSumSavings = 0;
  const enrichedLineItems = (lineItems ?? []).filter(lineItem => lineItem.id).map(lineItem => {
    var _userOffering$product, _userOffering$display;
    const currentProductTypeDetails = productTypesDetails == null ? void 0 : productTypesDetails.find(productTypeRes => {
      var _lineItem$productInfo;
      return productTypeRes.productTypeId === ((_lineItem$productInfo = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo.productTypeId);
    });
    const userOffering = currentProductTypeDetails == null ? void 0 : currentProductTypeDetails.userOffering;
    const trialDays = currentProductTypeDetails == null ? void 0 : currentProductTypeDetails.trialDays;
    const productInfo = userOffering == null || (_userOffering$product = userOffering.products) == null ? void 0 : _userOffering$product.find(product => {
      var _lineItem$productInfo2;
      return product.productId === ((_lineItem$productInfo2 = lineItem.productInfo) == null ? void 0 : _lineItem$productInfo2.productId);
    });
    const enrichedPriceSummary = CartEnrichers.enrichPriceSummmary({
      lineItem,
      currencySettings: userOffering == null ? void 0 : userOffering.currencySettings,
      pricingInfo: productInfo == null ? void 0 : productInfo.pricingInfo
    });
    const isLineItemInSale = Boolean(lineItem == null ? void 0 : lineItem.discountInfo);
    cartSumSavings += isLineItemInSale ? enrichedPriceSummary.totalSavingsDecimal : enrichedPriceSummary.cyclePricingProps.totalSavingsDecimal;
    return {
      ...lineItem,
      productInfo: {
        trialDays,
        productDisplayName: productInfo == null ? void 0 : productInfo.name,
        productTypeDisplayName: userOffering == null || (_userOffering$display = userOffering.displayProperties) == null ? void 0 : _userOffering$display.name,
        sbsProductId: productInfo == null ? void 0 : productInfo.sbsProductIdPoc,
        ...lineItem.productInfo
      },
      priceSummary: enrichedPriceSummary
    };
  });
  return {
    cart: {
      ...cart,
      totalAmounts: {
        ...cart.totalAmounts,
        savingsAmount: cartSumSavings
      },
      lineItems: ArrayUtils.reduceById(enrichedLineItems)
    }
  };
};
//# sourceMappingURL=cart.enricher.js.map